module.exports = __webpack_public_path__ + "img/stock3.38e5a4fa.png";